import { createGlobalStyle, css } from 'styled-components'
import { hpxTokens } from '../LayoutTheme/hpxTokens'

export const HpxGlobalStyleOverride = createGlobalStyle`
  && {
    ${({ theme: { isHpx } }) =>
      isHpx &&
      css`
        body {
          .instant-ink-enroll-hpx-button-override {
            &[disabled] {
              color: #ffffff;
            }
          }
          .instant-ink-enroll-hpx-secondary-button-override {
            &:not([disabled]) {
              color: ${hpxTokens.secondaryText};
              border-color: ${hpxTokens.secondaryBorder};

              &:hover {
                color: ${hpxTokens.secondaryText};
                border-color: ${hpxTokens.secondaryBorder};
              }

              &:active {
                background-color: ${hpxTokens.royalBlue3};
              }
            }
          }
        }
      `}
  }
`
